import React from 'react';
import PropTypes from 'prop-types';
import { EVENT_FAQ_CONST } from './data/constants';

import { eventActivitiesSelected, activitiesNotAllowed } from './data/utils';
import EventActivitiesContent from './content/EventActivitiesContent';
import EventActivitiesExpanded from './content/EventActivitiesExpanded';

const EventActivities = ({ faqData = {}, expanded = false }) => {
  const { MISC_ACTIVITIES, OTHER_PROHIBITED_ACTIVITY } = EVENT_FAQ_CONST;
  const hasOtherActivities = faqData.hasOwnProperty(MISC_ACTIVITIES) && faqData[MISC_ACTIVITIES].description;
  const availableActivities = eventActivitiesSelected(faqData);
  const prohibitedActivities = activitiesNotAllowed(faqData);
  const hasOtherProhibitedActivity = faqData.hasOwnProperty(OTHER_PROHIBITED_ACTIVITY) && '' !== faqData[OTHER_PROHIBITED_ACTIVITY];
  const hasSpecifiedProhibitedActivities = 0 < prohibitedActivities.length || hasOtherProhibitedActivity;
  if (expanded) {
    return (
      <>
        <EventActivitiesExpanded
          faqData={faqData}
          hasOtherProhibitedActivity={hasOtherProhibitedActivity}
          prohibitedActivities={prohibitedActivities}
        />
      </>
    );
  }
  return (
    <>
      <EventActivitiesContent
        faqData={faqData}
        availableActivities={availableActivities}
        hasOtherActivities={hasOtherActivities}
        hasSpecifiedProhibitedActivities={hasSpecifiedProhibitedActivities}
        hasOtherProhibitedActivity={hasOtherProhibitedActivity}
        prohibitedActivities={prohibitedActivities}
      />
    </>
  );
};

EventActivities.propTypes = {
  faqData: PropTypes.object,
  expanded: PropTypes.bool,
  intl: PropTypes.object
};

export default EventActivities;
